<template>
<div class="view times active">

    <div class="view-container">

        <div class="position-relative w-100 h-100">

            <div :class="{ 'container-fluid' : mode === 'multi' }">

                <div v-if="activeDurations.length > 1">
                    <div class="btn btn-filter me-2 mt-1"
                         :class="{ 'active' : duration === minutes, 'mb-3' : mode === 'multi', 'mb-0' : mode === 'single' }"
                         :key="'duration'+minutes"
                         @click="duration = minutes"
                         v-for="minutes in activeDurations"
                    >
                        {{ minutes }} min
                    </div>
                </div>

                <div class="search-area-text mt-1 mb-2" v-if="mode === 'multi'">
                    Visar tider från valt område kommande månad
                </div>

                <div class="d-flex justify-content-between mt-5 mb-2">
                    <div class="fold-btn" @click="subWeek()" :class="{ 'inactive' : isFirstWeek }"><img src="/images/card/fold-left.svg"></div>
                    <div class="text-center">
                        <h3 class="mb-0">Vecka {{ currentWeekNumber }}</h3>
                        <span style="font-size:14px; text-transform: capitalize;">{{ currentMonth }} {{ currentYear }}</span>
                    </div>
                    <div class="fold-btn justify-content-end" @click="addWeek()"  :class="{ 'inactive' : isLastWeek }"><img src="/images/card/fold-right.svg"></div>
                </div>

            </div>

            <div class="d-flex times-dates" style="border-top:1px solid #efefef; border-bottom:1px solid #efefef;">
                <div class="d-flex align-items-center text-center pt-2 pb-1" style="width: 14.28%; flex-direction: column;" v-for="day in days" :key="'h'+day">
                    <div style="font-weight:500; text-transform: uppercase; font-size: 12px;">{{ day.format('ddd') }}</div>
                    <div style="font-weight:600; font-size: 1.125rem; width:36px; height: 36px; border-radius:50%; line-height: 34px; padding:2px; text-align:center; margin-top:2px;" :class="{ 'bg-primary text-white' : isToday(day) }">{{ day.format('DD') }}</div>
                </div>
            </div>

            <div class="position-relative w-100"><div class="spinner" :class="{ 'active' : loading }"></div></div>

            <div class="time-table" :class="{ 'has-durations' : activeDurations.length > 1 }" v-if="!loading">
                <div class="d-flex w-100 text-center" style="min-height:100%; border-left:1px solid #e3e3e3;">
                    <div class="time-column" v-for="day in days" :key="'d'+day">
                        <a v-for="bookingTime in timesForDay(day)" :key="'t'+bookingTime.starts_at" @click="selectTimeslot(bookingTime)" style="" class="time-link">
                            {{ formatTime(bookingTime.starts_at) }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="time-table" v-if="loading">
                <div class="d-flex w-100 text-center" style="min-height:100%; border-left:1px solid #e3e3e3;">
                    <div class="time-column" v-for="index in 7" :key="'d'+index">

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import { mapState, mapStores } from 'pinia'
import { useBookingStore } from '../../stores/bookingStore'
import axios from 'axios'
import moment from 'moment'
import jQuery from 'jquery'

export default {
    props: {
        mode: {
            default: 'multi' // multi || single
        },
        modalClinicId: {
            default: null
        },
        modalClinicDurations: {
            default: []
        }
    },
    data () {
        return {
            times_from: moment().startOf('isoWeek').format('YYYY-MM-DD'),
            duration: null,
            times: [],
            loading: false
        }
    },
    computed: {
        ...mapStores(useBookingStore),
        ...mapState(useBookingStore, {
            clinics: state => state.clinics,
            productArea: state => state.productArea,
            durations: state => state.durations
        }),
        currentWeekNumber () {
            return moment(this.times_from).isoWeek()
        },
        currentMonth () {
            return moment(this.times_from).format('MMMM')
        },
        currentYear () {
            return moment(this.times_from).format('YYYY')
        },
        isFirstWeek () {
            if (this.currentWeekNumber == moment(Date.now()).isoWeek()) return true
            return false
        },
        isLastWeek () {
            if (this.currentWeekNumber == moment(Date.now()).add(3, 'week').isoWeek()) return true
            return false
        },
        days () {
            const days = []
            for (let i = 0; i < 7; i++) {
                days.push(moment(this.times_from).add(i, 'days'))
            }

            return days
        },
        activeDurations () {
            if (this.mode === 'multi') {
                return this.durations
            }

            return this.modalClinicDurations
        }
    },
    async created () {
        moment.locale('sv')

        this.duration = this.activeDurations[0]

        this.getTimes()

        // this.init()
    },
    watch: {
        clinics () {
            this.getTimes()
        },
        duration (val, oldVal) {
            if (oldVal === null) {
                return
            }
            this.getTimes()
        }
    },
    methods: {
        addWeek () {
            if (!this.isLastWeek) {
                this.times_from = moment(this.times_from).add(1, 'week').format('YYYY-MM-DD')

                this.getTimes()
            }
        },
        subWeek () {
            if (!this.isFirstWeek) {
                this.times_from = moment(this.times_from).subtract(1, 'week').format('YYYY-MM-DD')

                this.getTimes()
            }
        },
        timesForDay (day) {
            return this.times.filter(t => moment(t.starts_at).isSame(day, 'day'))
        },
        formatTime (starts_at) {
            return moment(starts_at).format('H:mm')
        },
        formatDayAndTime (starts_at) {
            return moment(starts_at).format('YYYY-MM-DD H:mm')
        },

        getTimes () {
            const clinic_ids = this.mode === 'multi' ? this.clinics.map(clinic => clinic.id) : [this.modalClinicId]

            this.loading = true

            axios.post('/booking/getBookingTimesAll', {
                mode: this.mode,
                clinic_ids: clinic_ids,
                from: this.times_from,
                duration: this.duration
            })
                .then(response => {
                    console.log('getBookingTimesAll complete')
                    console.log(response.data)

                    this.times = response.data.times
                    this.loading = false
                })
        },

        selectTimeslot (timeslot) {
            
            this.matomoTrackEvent('Booking', 'Open time', this.formatDayAndTime(timeslot.starts_at))

            if (this.mode === 'single' && timeslot.booking_link) {
                const link = document.createElement('a')
                link.href = timeslot.booking_link
                link.target = '_blank'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)

                this.matomoTrackEvent('Booking', 'Book', 'Single clinic time')

                return
            }

            const clinic_ids = this.mode === 'multi' ? this.clinics.map(clinic => clinic.id) : [this.modalClinicId]

            axios.post('/booking/getTimeslot', {
                clinic_ids: clinic_ids,
                time: timeslot.starts_at,
                duration: this.duration
            })
                .then(response => {
                    console.log('getBookingTimesAll complete')
                    console.log(response.data)

                    if (response.data.type === 'multi') {
                        this.bookingStore.timeSlot.time = timeslot.starts_at
                        this.bookingStore.timeSlot.clinics = response.data.clinics
                        this.bookingStore.timeSlot.duration = this.duration
                    }
                })
        },

        closeCustomModal () {
            jQuery('html').removeClass('modal-open')
        },

        isToday (day) {
            if (day.format('YYYYMMDD') == moment(Date.now()).format('YYYYMMDD')) return true
            return false
        },
    }
}
</script>
